<div class="flex align-items-center justify-content-center min-h-screen p-3">
	<div class="text-center max-w-30rem p-4">
		<img
			src="assets/images/dovecare-logo-lato.png"
			alt="DoveCare"
			class="w-10rem p-3 mb-4 border-round-lg bg-red-600"
		/>

		<i *ngIf="!maintenanceService.mode" class="pi pi-spin pi-spinner block text-2xl text-color-secondary mb-3"></i>

		<ng-container *ngIf="maintenanceService.mode === 'outage'">
			<h2 class="mb-3 text-color">DoveCare is temporarily unavailable.</h2>
			<p class="text-color-secondary line-height-3">We're working to restore service.</p>
		</ng-container>

		<ng-container *ngIf="maintenanceService.mode === 'maintenance'">
			<h2 class="mb-3 text-color">DoveCare is down for scheduled maintenance.</h2>
			<p *ngIf="etaText; else noEta" class="text-color-secondary line-height-3">
				We expect to be back around {{ etaText }}.
			</p>
			<ng-template #noEta>
				<p class="text-color-secondary line-height-3">We'll be back shortly.</p>
			</ng-template>
		</ng-container>

		<p class="text-color-secondary line-height-3">
			Need help now? Call
			<a href="tel:+18665758901" class="text-primary no-underline hover:underline"
				><strong>866-575-8901</strong></a
			>
			(Mon–Fri 6:30 AM–6:00 PM PT; Sat–Sun &amp; holidays 8:00 AM–4:30 PM PT) or email
			<a href="mailto:softwaresupport@horizonoxygen.com" class="text-primary no-underline hover:underline"
				><strong>softwaresupport&#64;horizonoxygen.com</strong></a
			>.
		</p>

		<p class="text-sm text-color-secondary mt-4">This page will refresh automatically when we're back.</p>
		<button pButton type="button" label="Try again" [loading]="checking" (click)="check()"></button>
	</div>
</div>
